import { useNavigate } from "react-router-dom";
import { productionDepartments } from "./data";

import Box from "@mui/material/Box";
import Fab from "@mui/material/Fab";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import { useState } from "react";
import KeyboardArrowDown from "@mui/icons-material/KeyboardArrowDown";

import DesignerTab from "./Departments/DesignerTab/DesignerTab";

const SelectedStyle = () => {
	const [activeDepartment, setActiveDepartment] = useState(productionDepartments.DESIGNER.key);
	const handleDepartmentChange = (e, val) => {
		setActiveDepartment(val);
	};
	const tabComponents = [
		{
			...productionDepartments.DESIGNER,
			component: <DesignerTab foreignKey={""} />,
		},
	];
	let scroll = 600;
	const handleScroll = () => {
		if (scroll > 2300) scroll = 0;
		window.scrollTo({ top: scroll, behavior: "smooth" });
		scroll += 600;
	};
	return (
		<Box sx={{ width: "100%", p: 1 }} position="relative">
			{/* <Box width="100%" display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap">
				<Stack>
					<Box display="flex" columnGap={1}>
						Created By:
						<PersonRounded />
						<Typography ba variant="subtitle1">
							{user.name}
						</Typography>
					</Box>
				</Stack>
				<Box
					display="flex"
					alignItems="center"
					height={"22px"}
					// columnGap={1}
					sx={{
						backgroundColor: statusOptions[selectedStyle?.status]?.color || yellow[400],
						color: "white",
						padding: "6px",
						borderRadius: "5px",
					}}>
					{statusOptions[selectedStyle?.status]?.icon}{" "}
					<Typography pl="3px"> {statusOptions[selectedStyle?.status]?.name}</Typography>
				</Box>
				<Divider variant="fullWidth" orientation="horizontal" flexItem sx={{ width: "100%", mt: 1 }} />
			</Box> */}
			<Tabs value={activeDepartment} onChange={handleDepartmentChange}>
				{Object.keys(productionDepartments).map((row) => {
					return <Tab label={productionDepartments[row].name} value={productionDepartments[row].key} />;
				})}
			</Tabs>

			{tabComponents?.map((row) => (
				<Box width="100%" margin="auto" key={row.key} display={row.key === activeDepartment ? "block" : "none"}>
					{row.component}
				</Box>
			))}
			<Fab
				size="small"
				color="primary"
				aria-label="add"
				sx={{ position: "fixed", right: "5%", bottom: "5%" }}
				onClick={handleScroll}>
				<KeyboardArrowDown />
			</Fab>
		</Box>
	);
};

export default SelectedStyle;
